/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Vedä muuttaaksesi paneelin kokoa',
  command_intelligence_close_aria: 'Sulje avustaja',
  command_intelligence_send_aria: 'Lähetä viesti',
  command_intelligence_stop_aria: 'Pysäytä vastaus',
  command_intelligence_composer_input_aria: 'Viesti Command Intelligenceen',
  command_intelligence_drawer_more_options: 'Lisäasetukset',
  command_intelligence_dock_position: 'Telakointisijainti',
  command_intelligence_dock_left: 'Vasen',
  command_intelligence_dock_right: 'Oikea',
  command_intelligence_dock_top: 'Ylä',
  command_intelligence_dock_bottom: 'Ala',
  command_intelligence_panel_layout: 'Paneelin asettelu',
  command_intelligence_panel_layout_overlap: 'Päällekkäinen sisältö',
  command_intelligence_panel_layout_push: 'Työnnä sisältöä',
  command_intelligence_panel_auto_hide_overlap: 'Piilota automaattisesti ulkopuolelle napsautettaessa',
  command_intelligence_session_reset: 'Nollaa keskustelu',
  command_intelligence_try_one_of_these: 'Kokeile jotakin näistä',
  command_intelligence_attach_hint: 'Liitä kontekstikohteita aloittaaksesi kysymysten esittämisen.',
  command_intelligence_attach_modal_title: 'Liitä konteksti',
  command_intelligence_attach_modal_subtitle: 'Valitse tämän näkymän kohteista. Jo liitetyt kohteet on harmaannettu.',
  command_intelligence_attach_modal_search_placeholder: 'Hae…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# kohde saatavilla} other {# kohdetta saatavilla}} · {selected} valittu',
  command_intelligence_attach_modal_empty: 'Ei liitettäviä kohteita',
  command_intelligence_attach_modal_no_results: 'Yksikään kohde ei vastaa hakua',
  command_intelligence_context_bar_attached_section: 'Liitetty ({count})',
  command_intelligence_context_bar_clear_attached: 'Tyhjennä',
  command_intelligence_context_bar_add: 'Liitä konteksti',
  command_intelligence_placeholder_ready: 'Kysy jotakin…',
  command_intelligence_placeholder_attach: 'Liitä konteksti kysyäksesi kysymyksen…',
  command_intelligence_composer_submit_hint: 'Enter lähettääksesi · Shift+Enter uudelle riville',
  command_intelligence_composer_stop_hint: 'Pysäytä · luonnostele seuraava viesti odottaessasi',
  command_intelligence_response_stopped: 'Vastaus pysäytetty',
  command_intelligence_generation_in_progress: 'Käsitellään kysymystäsi',
  command_intelligence_generation_trace_title: 'Suoritetut vaiheet',
  command_intelligence_generation_trace_toggle: 'Näytä vaiheet',
  command_intelligence_generation_trace_summary: '{completed}/{total} vaihetta valmis',
  command_intelligence_generation_trace_summary_generic: 'Generointivaiheet',
  command_intelligence_generation_tool_count: '{count, plural, one {# työkalu} other {# työkalua}}',
  command_intelligence_generation_turn_label: 'Kierros {turn}/{total}',
  command_intelligence_generation_turn_completed: 'Kierros {turn}/{total} valmis',
  command_intelligence_generation_turn_completed_elapsed: 'Kierros {turn}/{total} valmis ({seconds}s kulunut)',
  command_intelligence_generation_turn_completed_with_tools: 'Kierros {turn}/{total} valmis – käytti {tools}',
  command_intelligence_generation_tools_used: 'Käytti {tools}',
  command_intelligence_reasoning_thinking: 'Ajattelee…',
  command_intelligence_reasoning_thought_for_seconds: 'Ajatteli {seconds} sekuntia',
  command_intelligence_reasoning_waiting: 'Käsitellään kysymystäsi…',
  command_intelligence_attach_modal_done: 'Valmis',
  command_intelligence_attach_modal_attached_badge: 'liitetty',
  command_intelligence_attach_modal_attach: 'Liitä',
  command_intelligence_attach_modal_attach_count: 'Liitä ({count})',
  command_intelligence_attach_modal_close_aria: 'Sulje valitsin',
  command_intelligence_session_limit_context: 'Kontekstiraja saavutettu. Nollaa keskustelu jatkaaksesi.',
  command_intelligence_session_limit_prompt: 'Viestiraja saavutettu. Nollaa keskustelu jatkaaksesi.',
  command_intelligence_suggested_followups: 'Ehdotetut jatkokysymykset',
  command_intelligence_credit_warning_line: '{pct}% {scope}-kuukausittaisista tekoälykrediiteistä käytetty',
  command_intelligence_tooltip_prompts: '{count}/{max} viestiä ({pct}%)',
  command_intelligence_tooltip_context: '{used}/{max} kontekstitokenia ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Kontekstin käyttö näkyy ensimmäisen vastauksen jälkeen',
  command_intelligence_credits_loading: 'Ladataan krediittejä…',
  command_intelligence_credits_unavailable: 'Krediitit eivät ole saatavilla',
  command_intelligence_credits_tooltip: 'Kuukausittaiset tekoälykrediitit {monthKey}',
  command_intelligence_credits_tooltip_short: 'Kuukausittaiset tekoälykrediitit',
  command_intelligence_credits_scope_profile: 'Profiili',
  command_intelligence_credits_scope_entity: 'Yksikkö',
  command_intelligence_credits_used_of_cap: '{used}/{cap} krediittiä',
  command_intelligence_credits_used_no_cap: '{used} krediittiä käytetty',
  command_intelligence_credits_monthly_title: 'Kuukausittaiset tekoälykrediitit',
  command_intelligence_compare_aria: 'Vertaa agentteja',
  command_intelligence_compare_tooltip: 'Suorita sama kysymys useilla agenttiprofiileilla',
  command_intelligence_compare_cancelled: 'Vertailu peruutettu',
  command_intelligence_compare_branch_failed: 'Vertailuhaara epäonnistui',
  command_intelligence_compare_title: 'Agenttien vertailu',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} sisään / {outTok} ulos · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Hyvä vastaus',
  command_intelligence_feedback_bad_response: 'Huono vastaus',
  command_intelligence_feedback_dialog_title: 'Anna palautetta',
  command_intelligence_feedback_dialog_body:
    'Auta meitä parantamaan antamalla palautetta tästä vastauksesta. Palautteesi lähetetään operatiiviselle tiimillemme.',
  command_intelligence_feedback_response_label: 'Vastaus',
  command_intelligence_feedback_input_label: 'Palautteesi (valinnainen)',
  command_intelligence_feedback_input_placeholder: 'Mikä tässä vastauksessa oli väärin tai hyödytön?',
  command_intelligence_feedback_submit: 'Lähetä palaute',
  command_intelligence_feedback_submit_error: 'Palautteen lähetys epäonnistui. Yritä uudelleen.',
  command_intelligence_feedback_question_understanding: 'Ymmärsikö agentti mitä halusit?',
  command_intelligence_feedback_question_readability: 'Oliko vastaus helppo lukea ja käyttää?',
  command_intelligence_feedback_section_understanding: 'Ymmärtäminen',
  command_intelligence_feedback_section_readability: 'Luettavuus',
  command_intelligence_feedback_choice_none: 'Ei mitään',
  command_intelligence_feedback_choice_misunderstood_task: 'Ymmärsi tehtävän väärin',
  command_intelligence_feedback_choice_ignored_constraint: 'Ohitti rajoitteen',
  command_intelligence_feedback_choice_wrong_scope: 'Väärä laajuus',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Visuaalisesti vaikea lukea',
  command_intelligence_feedback_choice_wrote_too_much: 'Kirjoitti liikaa',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Selitys ei luotettava',
  command_intelligence_copy_aria: 'Kopioi leikepöydälle',
  command_intelligence_error_missing_invoke_permission:
    'Sinulla ei ole oikeutta käyttää Command Intelligencea tälle agentille. Pyydä ylläpitäjää myöntämään tarvittavat Intelligence-oikeudet (esimerkiksi analyst).',
  command_intelligence_access_denied_title: 'Pääsy vaaditaan',
  command_intelligence_error_session_expired: 'Istuntosi on vanhentunut. Päivitä sivu ja kirjaudu uudelleen sisään.',
};
